var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v(_vm._s(_vm.$t("message.theContactPage")))]),_c('div',{staticClass:"panel-body"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }